import { Component, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ConfigService } from 'src/app/services/config.service';
import { LinkedlnTrackingService } from 'src/app/services/linkedln-tracking.service';
import { PixelService } from 'src/app/services/pixel.service';
 import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
@Component({
    selector: 'empty-layout',
    templateUrl: './empty.component.html',
    styleUrls: ['./empty.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EmptyLayoutComponent implements OnInit, OnDestroy {
    // Private
    private _unsubscribeAll: Subject<any>;
    linkedinConversationId: any;
    fbVerificationCode: any;

    /**
     * Constructor
     */
    constructor(private configService: ConfigService,
        private pixelService : PixelService,
        private linkedInTrackingService: LinkedlnTrackingService,
        private renderer: Renderer2,
        private router: Router,
        private ecryptService: EcryptServiceService 

    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */

    data: any;

    ngOnInit() {

        this.getConfigData();

    }

    googleAnalyticsId: any;

    iframeUrl: string;

    facebookPixelId:any;

    getConfigData() {
        this.configService.getKey()
            .subscribe(
               (response:any) => {

          
          let configData = response;

        let config =response;

        if(response.encryptedText!=null){
     const decrypted = this.ecryptService.decryptionAES(response.encryptedText);
       configData = JSON.parse(decrypted);
        }


        let data=configData;

                    this.data = configData;


                    if (data != null) {

                        this.googleAnalyticsId = this.data['googleAnalyticsId'];

                        this.facebookPixelId = this.data['facebookPixelId'];

                        this.fbVerificationCode = this.data['fbVerificationCode'];

                        if (this.data['linkedinConversationId'] != undefined) {

                            this.linkedinConversationId = this.data['linkedinConversationId'];
                        
                            this.linkedin(this.linkedinConversationId);
                         }

                        if (this.googleAnalyticsId != null && this.googleAnalyticsId != undefined && this.googleAnalyticsId != '') {

                            this.googleAnalytics(this.googleAnalyticsId);

                        }

                        if (this.router.url.includes("/whatsapp")) {

                             if (this.fbVerificationCode != null && this.fbVerificationCode != undefined && this.fbVerificationCode != '') {

                                this.pixelService.initialize(this.fbVerificationCode);
                            }

                        } else {
                            if (this.facebookPixelId != null && this.facebookPixelId != undefined && this.facebookPixelId != '') {

                                this.pixelService.initialize(this.facebookPixelId);
                            }
                        }

                        
             


                    }



                }, error => {

                }
            );
    }
    linkedin(partnerId: string) {

        (window as any)._linkedin_data_partner_ids = (window as any)._linkedin_data_partner_ids || [];
        (window as any)._linkedin_data_partner_ids.push(partnerId);
      
        if (!(window as any).lintrk) {
          (window as any).lintrk = function(a, b) {
            (window as any).lintrk.q = (window as any).lintrk.q || [];
            (window as any).lintrk.q.push([a, b]);
          };
        }
      
        const script = this.renderer.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
      
        script.onload = () => {
          console.log('LinkedIn script loaded.');
          this.linkedInTrackingService.notifyScriptLoaded();
        };
      
        this.renderer.appendChild(document.head, script);
      }



    googleAnalytics(googleAnalyticsId) {

        let key = googleAnalyticsId;

        this.iframeUrl = "https://www.googletagmanager.com/ns.html?id=" + key

        const gTagManagerScript = document.createElement('script');
        gTagManagerScript.async = true;
        gTagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${key}`;
        document.head.appendChild(gTagManagerScript);

        // register google analytics
        const gaScript = document.createElement('script');
        gaScript.innerHTML = `
       window.dataLayer = window.dataLayer || [];
       function gtag() { dataLayer.push(arguments); }
       gtag('js', new Date());
       gtag('config', '${key}');
     `;
        document.head.appendChild(gaScript);

        const noScript = document.createElement('noscript');
        noScript.innerHTML = `
              <iframe src="https://www.googletagmanager.com/ns.html?id=${key}" 
              height="0" width="0" style="display:none;visibility:hidden"></iframe>
            `;
        document.body.appendChild(noScript);


    }

    

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
